import axios from 'api';

require('dotenv').config();

export const GET_BRANDS = '[CONSOLE] GET BRANDS';

export const getBrands = () => {
  return dispatch =>
    axios
      .get('/brands')
      .then(response => {
        dispatch({
          type: GET_BRANDS,
          payload: response.data
        });
      })
      .catch(err => err);
};
